<template>
  <v-container>
    <module-bar title="REPORTE DE CORREDORES" icon="mdi-file-chart" />

    <v-row v-if="loadingData">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="1" size="60" />
      </v-col>
    </v-row>

    <v-row v-if="loadedData">
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar corredor" single-line hide-details
          style="max-width: 400px" class="mb-5"></v-text-field>

        <v-card outlined>
          <v-data-table :search="search" :headers="headers" :items="items" :items-per-page="10" :mobile-breakpoint="800"
            @click:row="openDialogRunner">
            <template v-slot:[`item.assigned`]="{ item }">
              <v-chip small :text-color="item.assigned != 'No asignado' ? 'white' : 'black'"
                :color="item.assigned != 'No asignado' ? 'green' : 'default'">{{ item.assigned }}
              </v-chip>
            </template>

            <template v-slot:[`item.photo`]="{ item }">
              <v-avatar size="38">
                <v-img :src="item.photo ? item.photo : photoEmpty" />
              </v-avatar>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogRunner" persistent width="800">
      <v-card>
        <v-card-text>
          <runner-form schema="edit" :runner="runner" :click="click" title="EDITAR CORREDOR"
            @closeDialogRunner="closeDialogRunner" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import RunnerForm from "../../components/Forms/RunnerForm.vue";
import photoEmpty from "../../assets/profile.jpeg";

export default {
  components: {
    ModuleBar,
    RunnerForm,
  },

  beforeMount() {
    this.loadingData = true;
    this.loadedData = false;
    setTimeout(() => {
      this.$store.dispatch("findRunnersAction").then((res) => {
        this.items = res;
        this.loadingData = false;
        this.loadedData = true;
      });
    }, 500);
  },

  data() {
    return {
      photoEmpty: photoEmpty,
      loadingData: true,
      loadedData: false,
      dialogRunner: false,
      runner: null,
      search: "",
      click: 0,
      headers: [
        {
          text: "Foto",
          value: "photo",
          width: "20%",
        },
        {
          text: "Nombre",
          value: "name",
          width: "20%",
        },

        {
          text: "Zona",
          value: "zone",
          width: "20%",
        },

        {
          text: "Distrito",
          value: "district",
          width: "20%",
        },
        {
          text: "Nota",
          aling: "left",
          value: "note",
          width: "40%",
        },
      ],
      items: [],
    };
  },



  methods: {
    openDialogRunner(value) {
      this.runner = value;
      this.dialogRunner = true;
      this.click++;
    },

    closeDialogRunner(data) {
      this.dialogRunner = false;
      if (data) {
        let runnerId = data.runner ? data.runner.id : data.id;
        let index = this.items.findIndex((v) => v.id == runnerId);

        if (data.is_delete) {
          this.items.splice(index, 1);
          return;
        }
        this.items.splice(index, 1, data.runner);

      }
    },
  },
};
</script>
